export const KEYS = {
  PERIOD_AM: 'AM',
  PERIOD_PM: 'PM',
  TIMEZONE_PREFIX: 'UTC',
};
